import React, { useEffect, useState } from "react";
import { Table, Button, Modal, Checkbox, Select, Radio, Spin, message, Tooltip } from "antd";
import * as XLSX from "xlsx";
import CustomSearch from "../../components/search/CustomSearch";
import Pnation from "../../components/Pagination/pagination";
import { formatIndianDate } from "../../utils/Constant";
import { useNavigate, useLocation } from "react-router-dom";
import HoverIcon from "../../components/icons/HoverIcon";
import { FileTextOutlined, FileExcelOutlined, EyeOutlined, EyeInvisibleOutlined, FileSyncOutlined, SyncOutlined } from "@ant-design/icons"; // Ant Design icons
import MultiFilterSelect from "../../components/Filter/MultiFilterSelect";
import axiosInstance from "../../utils/axiosInstance";
import { useSelector } from "react-redux";


const { Option } = Select;

const selectedBgColor = "bg-[#A395DA]"; // Custom RGB color

const initialColumns = [
    { title: <Tooltip className="whitespace-nowrap" title="Ticket Id">Ticket Id</Tooltip>, width:100, dataIndex: "id", key: "id" , ellipsis: true, },
    { title: <Tooltip className="whitespace-nowrap" title="Subject">Subject</Tooltip>,width:100, ellipsis: true, dataIndex: "subject", key: "subject" },
    { title: <Tooltip className="whitespace-nowrap" title="E-mail">E-mail</Tooltip>,width:100, ellipsis: true, dataIndex: "user_email", key: "user_email" },
    { title: <Tooltip className="whitespace-nowrap" title="Requester">Requester</Tooltip>,width:100, ellipsis: true, dataIndex: "user_name", key: "user_name" }, // Default column
    { title: <Tooltip className="whitespace-nowrap" title="Status">Status</Tooltip>, width:70, ellipsis: true, dataIndex: "status", key: "status" },
    { title: <Tooltip className="whitespace-nowrap" title="Remark">Remark</Tooltip>,width:100, ellipsis: true, dataIndex: "cancel_message", key: "cancel_message" },
    { title: <Tooltip className="whitespace-nowrap" title="Company Name">Company Name </Tooltip>, width: 160, ellipsis: true, dataIndex: "company_name", key: "company_name" },
    { title: <Tooltip className="whitespace-nowrap" title="Type">Type</Tooltip>,width:70, ellipsis: true, dataIndex: "subject_type", key: "subject_type" },
    { title: <Tooltip className="whitespace-nowrap" title="Last Update">Last Update</Tooltip>, width:160, ellipsis: true, dataIndex: "last_status_update", key: "last_status_update", render: (date) => formatIndianDate(date) },
    {title: <Tooltip className="whitespace-nowrap" title="Created Date">Created Date</Tooltip>,width:160, ellipsis: true, dataIndex: "created_at", key: "created_at", render: (date) => formatIndianDate(date), },
];
const middleIndex = Math.ceil(initialColumns.length / 2);
const firstHalf = initialColumns.slice(0, middleIndex);
const secondHalf = initialColumns.slice(middleIndex);

const filterOptions = ['Open', 'Work in progress', 'Canceled', 'Resolved'];

const TicketList = () => {
    const select = useSelector((state) => state.auth.userInfo);
    const user_role =  select?.role;
    const [visible, setVisible] = useState(false);
    const [exportVisible, setExportVisible] = useState(false);
    const [exportStep, setExportStep] = useState(1);
    const [tempColumns, setTempColumns] = useState(
        initialColumns.map((col) => col.key)
    );
    const [selectedColumns, setSelectedColumns] = useState(initialColumns);
    //   const [selectedFilters, setSelectedFilters] = useState([]);
    const [exportFields, setExportFields] = useState(
        initialColumns.map((col) => col.key)
    );
    const [exportType, setExportType] = useState("csv");

    //
    const [tickets, setTickets] = useState([]);
    const [isLoading, setIsloading] = useState(false)
    const [searchKeyword, setSearchKeyword] = useState({ search_keyword: '', status: ['Open'] });

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedStatus, setSelectedStatus] = useState(null);
    const [currentRecord, setCurrentRecord] = useState(null);
    const [isLoadingCancelBtn, setIsLoadingCancelBtn] = useState(false)

    const navigate = useNavigate();
    const location = useLocation();
    const isSupportRoute = location.pathname.includes("/admin/support");
    const statusOptions = ["Open", 'Work in progress', "Resolved", "Canceled"];


    useEffect(() => {
        handleApplyColumns()
    }, [isLoadingCancelBtn])

    // Handle status change
    const handleStatusChange = (value) => {
        setSelectedStatus(value);
    };


    const onStatusChange = async () => {
        try {
            setIsLoadingCancelBtn(true);
            const response = await  axiosInstance.post( `/tickets/${currentRecord.id}/update_status/`, { status: selectedStatus })
            message.success(response.data.message);
            setTickets(val => {
                val.find((item) => {
                    if (item.id == currentRecord.id) {
                        item.status = selectedStatus
                    }
                })
                return [...val]
            })

        } catch (error) {
            message.error(error.response.data.error)
            console.error("Error fetching tickets:", error);
        } finally {
            setIsModalOpen(false)
            setIsLoadingCancelBtn(false);
            setSelectedStatus([])
            setCurrentRecord({})
            setIsModalOpen(false)
        }
    };

    const handleAction = (record) => {
        setCurrentRecord(record);
        setIsModalOpen(true);
    };
    const handleApplyColumns = () => {
        setSelectedColumns(
            [...initialColumns.filter(
                (col) => tempColumns.includes(col.key) || col.key === "name"
            ),
            ...user_role === "superadmin" && !isSupportRoute ? [{
                title: "Status Change",
                dataIndex: "actions",
                key: "actions",
                width:150,
                ellipsis:true,

                render: (_, record) => (

                    <HoverIcon
                        icon={<SyncOutlined  className="!text-[#CD7F32]"  />}
                        tooltip="Change Status"
                        color="#CD7F32"
                        hoverBgColor="#4B0082"
                        onClick={(e) => {
                            if (e?.stopPropagation) e.stopPropagation();
                            handleAction(record);
                        }}
                        hoverColor="#FF4500"
                        disabled={isLoadingCancelBtn} // Force-enable for testing
                        isLoading={currentRecord?.id == record.id && isLoadingCancelBtn} // Disable loading for testing
                    />

                ),
            }] : [],
            ]
        );
        setVisible(false);
    };

    const handleColumnChange = (key, checked) => {
        setTempColumns((prev) =>
            checked ? [...prev, key] : prev.filter((col) => col !== key)
        );
    };
    const onPeding = (val) => {
        setIsloading(val)
    }
    const getData = (data) => {
        setTickets(data)
    }

    const handleSearch = (value) => {
        setSearchKeyword((val) => {
            val.search_keyword = value;
            return { ...val }
        })
    };


    const handleExport = () => {
        const filteredData = tickets.map((row) =>
            exportFields.reduce((acc, field) => {
                acc[field] = row[field]; // Pick only selected fields
                return acc;
            }, {})
        );

        const ws = XLSX.utils.json_to_sheet(filteredData);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

        if (exportType === "csv" || exportType === "both") {
            XLSX.writeFile(wb, "exported_data.csv", { bookType: "csv" });
        }
        if (exportType === "excel" || exportType === "both") {
            XLSX.writeFile(wb, "exported_data.xlsx", { bookType: "xlsx" });
        }

        setExportVisible(false);
    };

    return (
        <div className="">
            <div className="text-black pb-3  flex items-center justify-between">
                <div className="flex flex-row justify-center align-middle">
                    <MultiFilterSelect filterOptions={filterOptions} searchKeyword={searchKeyword} setSearchKeyword={setSearchKeyword} />
                    <div className="pl-4">
                        <CustomSearch onSearch={handleSearch} />
                    </div>
                </div>
                <div className="w-full flex flex-row flex-wrap items-center justify-end gap-4">
                    <Button
                        type="primary"
                        onClick={() => {
                            setTempColumns(selectedColumns.map((col) => col.key));
                            setVisible(true);
                        }}
                        className="!bg-[rgb(78,54,163)] !text-white px-6 rounded-lg shadow-md transition-all duration-300 hover:!bg-[rgb(100,13,13)] hover:shadow-lg"
                    >
                        Select Columns
                    </Button>

                    <Button
                        type="primary"
                        onClick={() => {
                            setExportVisible(true);
                            setExportStep(1);
                        }}
                        className="!bg-[rgb(78,54,163)] !text-white px-6 rounded-lg shadow-md transition-all duration-300 hover:!bg-[rgb(100,13,13)] hover:shadow-lg"
                    >
                        Export
                    </Button>
                </div>


            </div>
            <div className=" border border-gray-300">
                <Spin spinning={isLoading} tip="Loading...">
                    <Table
                        columns={selectedColumns}
                        dataSource={tickets}
                        scroll={{ x: 1220, y: 400 }}
                        pagination={false}
                        size="small"

                        onRow={(record) => ({
                            onClick: () => navigate(!isSupportRoute ? `/admin/setting/ticket/details/${record.id}` : `/admin/support/details/${record.id}`),
                        })}
                        className="cursor-pointer text-[12px] [&_.ant-table-cell]:p-1 [&_.ant-table-cell]:text-[12px]"

                    />
                </Spin>
            </div>
            <Pnation itmeName='Tickets' onPeding={onPeding} onCngPage={getData} url='/tickets/' plod={searchKeyword} />

            <Modal
                title="Select Columns"
                visible={visible}
                onCancel={() => setVisible(false)}
                footer={
                    <Button type="primary" onClick={handleApplyColumns}>
                        Apply
                    </Button>
                }
            >
                <div className="p-4 border rounded-lg shadow-md bg-white dark:bg-[#17153B] transition-transform hover:scale-105">
                    <h3 className="text-lg font-semibold mb-3 text-[#A395DA] border-b-2 border-[#A395DA] pb-2 text-center">
                        📊 Manage Table Columns
                    </h3>

                    <div className="grid grid-cols-2 gap-2">
                        {initialColumns.map((col) => {
                            const isChecked = tempColumns.includes(col.key) || col.key === "name";

                            return (
                                <label
                                    key={col.key}
                                    className={`flex items-center justify-between px-3 py-2 rounded-md cursor-pointer transition-all border
                ${isChecked
                                            ? "bg-[#A395DA] text-white border-transparent shadow-md"
                                            : "bg-gray-100 hover:bg-gray-200 border-gray-300 text-gray-800"
                                        }`}
                                >
                                    <Checkbox
                                        checked={isChecked}
                                        disabled={col.key === "name"}
                                        onChange={(e) => handleColumnChange(col.key, e.target.checked)}
                                        className="scale-125"
                                    />

                                    <span className={`flex-1 text-sm font-medium pl-3 ${col.key === "name" ? "font-bold text-gray-500" : ""}`}>
                                        {col.title}
                                    </span>

                                    {isChecked ? (
                                        <EyeOutlined className="text-white text-lg animate-fade-in" />
                                    ) : (
                                        <EyeInvisibleOutlined className="text-gray-500 text-lg" />
                                    )}
                                </label>
                            );
                        })}
                    </div>
                </div>
            </Modal>

            <Modal
                title="Export Data"
                visible={exportVisible}
                onCancel={() => setExportVisible(false)}
                footer={
                    exportStep === 1 ? (
                        <Button
                            type="primary"
                            disabled={exportFields.length === 0}
                            onClick={() => setExportStep(2)}
                        >
                            Next
                        </Button>
                    ) : (
                        <>
                            <Button onClick={() => setExportStep(1)}>Previous</Button>
                            <Button
                                type="primary"
                                onClick={handleExport}
                            // onClick={() => {
                            //     setExportVisible(false);
                            // }}
                            >
                                Export
                            </Button>
                        </>
                    )
                }
            >
                {exportStep === 1 ? (
                    <div className="bg-white dark:bg-[#17153B] shadow-xl rounded-lg p-6 w-full max-w-md transition-transform hover:scale-105">
                        <h3 className="text-lg font-semibold text-center text-[#A395DA] border-b-2 border-[#A395DA] pb-2">
                            🚀 Select Fields to Export
                        </h3>

                        <div className="mt-4 grid grid-cols-2 gap-4">
                            {[firstHalf, secondHalf].map((columns, index) => (
                                <div key={index} className="space-y-3">
                                    {columns.map((col) => {
                                        const isSelected = exportFields.includes(col.key);

                                        return (
                                            <label
                                                key={col.key}
                                                className={`flex items-center justify-between px-3 py-2 rounded-lg cursor-pointer transition-all duration-300 border 
                             ${isSelected
                                                        ? `${selectedBgColor} text-white border-transparent shadow-md`
                                                        : "bg-gray-100 hover:bg-gray-200 border-gray-300 text-gray-800"
                                                    }`}
                                            >
                                                <Checkbox
                                                    checked={isSelected}
                                                    onChange={(e) => {
                                                        const checked = e.target.checked;
                                                        setExportFields((prev) =>
                                                            checked ? [...prev, col.key] : prev.filter((f) => f !== col.key)
                                                        );
                                                    }}
                                                    className="scale-125"
                                                />
                                                <span className="flex-1 text-sm font-medium pl-3">{col.title}</span>
                                                {!isSelected ? (
                                                    <FileExcelOutlined className="text-gray-600 text-lg animate-pulse" />
                                                ) : (
                                                    <FileTextOutlined className="text-white-700 text-lg" />
                                                )}
                                            </label>
                                        );
                                    })}
                                </div>
                            ))}
                        </div>
                    </div>

                ) : (
                    <div className="p-4 border rounded-lg shadow-md bg-white dark:bg-[#17153B] transition-transform hover:scale-105">
                        <h3 className="text-lg font-semibold mb-3 text-[#A395DA] border-b-2 border-[#A395DA] pb-2 text-center">
                            📤  Select Export Type
                        </h3>

                        <Radio.Group
                            value={exportType}
                            onChange={(e) => setExportType(e.target.value)}
                            className="flex flex-col space-y-3"
                        >
                            <Radio value="csv" className="flex items-center space-x-2 p-2 rounded-md hover:bg-gray-100 dark:hover:bg-gray-800  transition-all">
                                <FileTextOutlined className="text-blue-500 dark:text-blue-700 text-lg" />
                                <span className="text-gray-700 dark:text-gray-200 font-medium">CSV</span>
                            </Radio>

                            <Radio value="excel" className="flex items-center space-x-2 p-2 rounded-md hover:bg-gray-100 dark:hover:bg-gray-800  transition-all">
                                <FileExcelOutlined className="text-green-500 dark:text-green-700 text-lg" />
                                <span className="text-gray-700 dark:text-gray-200 font-medium">Excel</span>
                            </Radio>

                            <Radio value="both" className="flex items-center space-x-2 p-2 rounded-md hover:bg-gray-100 dark:hover:bg-gray-800  transition-all">
                                <FileSyncOutlined className="text-yellow-500 dark:text-yellow-700 text-lg" />
                                <span className="text-gray-700 dark:text-gray-200 font-medium">Both</span>
                            </Radio>
                        </Radio.Group>
                    </div>
                )}
            </Modal>

            <Modal
                title="Change Ticket Status"
                open={isModalOpen}
                onOk={onStatusChange}
                onCancel={() => {
                    setSelectedStatus([])
                    setCurrentRecord({})
                    setIsModalOpen(false)
                }}
                okText="Submit"
                okButtonProps={{ disabled: !selectedStatus || isLoadingCancelBtn, loading: isLoadingCancelBtn }}
            >
                <p>Select a new status:</p>
                <Select
                    style={{ width: "100%" }}
                    placeholder="Select status"
                    onChange={handleStatusChange}
                    value={selectedStatus?.length ? selectedStatus : undefined}
                >
                    {statusOptions.map((status) => (
                        <Option key={status} value={status}>
                            {status}
                        </Option>
                    ))}
                </Select>
            </Modal>
        </div>
    );
};

export default TicketList;
